import { render } from "./OutcomePerReasonChart.vue?vue&type=template&id=a536ac36&scoped=true"
import script from "./OutcomePerReasonChart.vue?vue&type=script&lang=js"
export * from "./OutcomePerReasonChart.vue?vue&type=script&lang=js"

import "./OutcomePerReasonChart.vue?vue&type=style&index=0&id=a536ac36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a536ac36"],['__file',"src/components/Charts/OutcomePerReasonChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a536ac36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a536ac36', __exports__)) {
    api.reload('a536ac36', __exports__)
  }
  
  module.hot.accept("./OutcomePerReasonChart.vue?vue&type=template&id=a536ac36&scoped=true", () => {
    api.rerender('a536ac36', render)
  })

}


export default __exports__